module.exports = __webpack_public_path__ + "img/Group7.a7cfbd9d.png";